export const firebaseConfig = {
  apiKey: "AIzaSyBbY2wpWwDK4GjJxmQUo5-Xz6rAdQVUcpI",
  authDomain: "aplicativo-polivias.firebaseapp.com",
  databaseURL: "https://aplicativo-polivias-default-rtdb.firebaseio.com",
  projectId: "aplicativo-polivias",
  storageBucket: "aplicativo-polivias.firebasestorage.app",
  messagingSenderId: "441788982534",
  appId: "1:441788982534:web:80cef12185880e36ee6a87",
  measurementId: "G-LP9E1EVW6T"
};